import { getCommonWidget } from "../../dashWidgetHelper";
import {
    PRODUTURO_PIE_COLORS, commonWidgets,
    getProfuturoFacilidad, getProfuturoNpsAcumulado,
    getProfuturoNpsPorMes, getProfuturoSatisfaccion,
    PRODUTURO_SCALE_5_COLORS, getProfuturoCustomerJourney
} from "../commonWidgetsProfuturo";

export default {
    title: 'Acompañamiento Dashboard',
    description: 'Acompañamiento Dashboard',
    backgroundClassName: (filters: FiltersUI) => 'epsilon-hero-bg',
    widgets: (filters: FiltersUI) => [
        {
            title: 'Principales Indicadores',
            size: [4, 1],
            type: 'label',
            config: { color: '#B7AADC' },
        },
        getProfuturoNpsAcumulado({
            size: [1, 2],
            indicator: 'portal_privado_pensiones_23'
        }),
        getProfuturoNpsPorMes({
            size: [1, 2],
            indicator: 'portal_privado_pensiones_23',
            helpText: 'A partir de tu experiencia con el portal web Profuturo Pensiones, en una escala de 0 a 10, ¿qué tan probable es que recomiendes a Profuturo con un amigo o familiar?'
        }),
        getProfuturoSatisfaccion({
            size: [1, 2],
            indicator: 'portal_privado_pensiones_1',
            helpText: 'A partir de tu interacción con el portal web Profuturo Pensiones ¿Qué tan satisfecho estás con las funciones y características disponibles?',
            extraConfigs: {
                colors: PRODUTURO_SCALE_5_COLORS
            }
        }),
        getProfuturoFacilidad({
            size: [1, 2],
            indicator: 'portal_privado_pensiones_5',
            helpText: 'Pensando en la última consulta o trámite que hiciste a través del portal web Profuturo Pensiones, ¿qué tan fácil fue realizarlo?',
            extraConfigs: {
                colors: PRODUTURO_SCALE_5_COLORS
            },
        }),
        
        getProfuturoCustomerJourney({
             id: 'cj-acompanamiento',
             size: [2, 2],
             indicators: [
               { name: 'portal_privado_pensiones_1', formula: 'count-number' }, //csat
               { name: 'portal_privado_pensiones_5', formula: 'count-number' }, //facilidad
               { name: 'portal_privado_pensiones_23', formula: 'nps-10' }, //nps
             ],
             title: 'Customer Journey: Top Two Box',
           }),

        {
            title: 'Quiebres y Motivadores en la satisfacción',
            size: [4, 1],
            type: 'label',
            config: { color: '#B7AADC' },
        },
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'wordCount',
            title: 'Funciones que esperabas encontrar y no están disponibles',

            size: [2, 2],
            indicator: 'portal_privado_pensiones_3',
            helpText: '¿Qué funciones o características esperabas encontrar en el portal y no están disponibles?'
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'wordCount',
            title: 'Funciones que más valoraste',

            size: [2, 2],
            indicator: 'portal_privado_pensiones_4',
            helpText: '¿Qué funciones o características valoraste más al utilizar el portal?'
        }),

        //
        {
            title: 'Quiebres y Motivadores en la facilidad',

            size: [4, 1],
            type: 'label',
            config: { color: '#B7AADC' },
        },
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'pieGenericMedium',
            title: 'Facilidad: clientes insatisfechos',

            size: [2, 2],
            indicator: 'portal_privado_pensiones_6',
            helpText: '¿Por qué resultó de esa manera? ',
            extraConfigs: {
                colors: PRODUTURO_PIE_COLORS,
                itemGap: 6,
                center: ['27%', '55%'],
            }
        }),
        /*getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'pieGenericMedium',
            title: 'Facilidad: clientes neutros',

            size: [2, 2],
            indicator: 'portal_privado_pensiones_8',
            helpText: '¿Qué podríamos hacer para mejorar la facilidad?',
            extraConfigs: {
                colors: PRODUTURO_PIE_COLORS,
                itemGap: 6,
                center: ['27%', '55%'],
            }
        }),
        */
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'pieGenericMedium',
            title: 'Facilidad: clientes satisfechos',

            size: [2, 2],
            indicator: 'portal_privado_pensiones_10',
            helpText: '¿Por qué resultó fácil? ',
            extraConfigs: {
                colors: PRODUTURO_PIE_COLORS,
                itemGap: 6,
                center: ['27%', '55%'],
            }
        }),


        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'pieGenericMedium',
            title: 'Último trámite consultado',

            size: [2, 2],
            indicator: 'portal_privado_pensiones_12',
            helpText: '¿Cuál fue el último trámite o consulta que realizaste a través del portal web Profuturo Pensiones? ',
            extraConfigs: {
                colors: PRODUTURO_PIE_COLORS,
                itemGap: 6,
                center: ['27%', '55%'],
            }
        }),

        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'pieGenericMediumSiNo',
            title: 'Resolución del Trámite',

            size: [2, 2],
            helpText: '¿Pudiste resolver tu trámite o consulta?',
            indicator: 'portal_privado_pensiones_14',
            extraConfigs: {
                itemGap: 10,
                center: ['27%', '55%'],
            }
        }),

        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'pieGenericMedium',
            title: 'Efectividad: Clientes insatisfechos',

            size: [2, 2],
            helpText: '¿Por qué no pudiste resolver tu trámite o consulta? ',
            indicator: 'portal_privado_pensiones_15',
            extraConfigs: {
                itemGap: 10,
                colors: PRODUTURO_PIE_COLORS,
                center: ['27%', '55%'],
            }
        }),
        getCommonWidget({
           commonWidgets: commonWidgets,
           name: 'wordCount',
           title: 'Efectividad detallada: Clientes insatisfechos',
           size: [2, 2],
           indicator: 'portal_privado_pensiones_17',
           helpText: 'Lamentamos que no hayas podido resolver tu trámite/consulta, ¿Podrías contarnos más sobre la dificultad que encontraste? Esto nos ayuda a mejorar. '
       }),

        {
            title: 'Atributos en la experiencia de Grado de SATISFACCIÓN',
            size: [4, 1],
            type: 'label',
        },
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'stackedBar',
            title: 'La rapidez y facilidad para ingresar al portal web',
            size: [4, 1],
            helpText: '¿Qué tan satisfecho estás con cada uno de los siguientes aspectos?',
            indicator: 'portal_privado_pensiones_18',
            extraConfigs: {
                colors: PRODUTURO_SCALE_5_COLORS
            },
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'stackedBar',
            title: 'La facilidad para encontrar la información / trámite que necesitaba',
            size: [4, 1],
            helpText: '¿Qué tan satisfecho estás con cada uno de los siguientes aspectos?',
            indicator: 'portal_privado_pensiones_19',
            extraConfigs: {
                colors: PRODUTURO_SCALE_5_COLORS
            },
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'stackedBar',
            title: 'El modo en que pude resolver mis consultas / trámites',
            size: [4, 1],
            helpText: '¿Qué tan satisfecho estás con cada uno de los siguientes aspectos?',
            indicator: 'portal_privado_pensiones_20',
            extraConfigs: {
                colors: PRODUTURO_SCALE_5_COLORS
            },
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'stackedBar',
            title: 'Lo simple y sencillo que resultó navegar en el portal web',
            size: [4, 1],
            helpText: '¿Qué tan satisfecho estás con cada uno de los siguientes aspectos?',
            indicator: 'portal_privado_pensiones_21',
            extraConfigs: {
                colors: PRODUTURO_SCALE_5_COLORS
            },
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'stackedBar',
            title: 'La claridad de la información que me brindó el portal web',
            size: [4, 1],
            helpText: '¿Qué tan satisfecho estás con cada uno de los siguientes aspectos?',
            indicator: 'portal_privado_pensiones_22',
            extraConfigs: {
                colors: PRODUTURO_SCALE_5_COLORS
            },
        }),
        getCommonWidget({
             commonWidgets: commonWidgets,
             name: 'wordCount',
             title: 'Sugerencias y comentarios',
             size: [2, 2],
             indicator: 'portal_privado_pensiones_24',
             helpText: '¿Hay alguna sugerencia o comentario que nos quieras realizar sobre el portal web Profuturo Pensiones'
         }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'textAnalysis',
            title: 'Análisis de Sentimientos',
            size: [4, 4],
            indicator: 'SENTIMENT'
        }),

    ]
} as DasboardConfig
